// @flow

import React from 'react'
import type { Node } from 'react'

const NBSP = (): Node => <>&nbsp;</>

export default NBSP
